<template>
  <div class="coupon-field">
    <div
      v-if="!expanded"
      class="coupon-field__trigger"
      @click="expanded = true"
    >
      <span class="coupon-field__trigger-text"
        >&iquest;Tienes un cup&oacute;n?</span
      >
    </div>

    <div v-else class="coupon-field__form">
      <div class="coupon-field__input-wrap">
        <input
          v-model="code"
          type="text"
          class="coupon-field__input"
          placeholder="Ej: PROMO20"
          maxlength="20"
          @keyup.enter="applyCoupon"
        />
        <button
          class="coupon-field__btn"
          :disabled="!code || loading"
          @click="applyCoupon"
        >
          {{ loading ? "..." : "Aplicar" }}
        </button>
      </div>

      <div
        v-if="couponValid && couponValid.valid"
        class="coupon-field__success"
      >
        <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
          <path
            d="M3 8.5L6.5 12L13 4"
            stroke="#1D9E75"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span
          >Cup&oacute;n aplicado{{
            couponValid.discount_preview
              ? ": " + couponValid.discount_preview.description
              : ""
          }}</span
        >
        <button class="coupon-field__clear" @click="clearCoupon">
          &times;
        </button>
      </div>

      <div v-if="couponValid && !couponValid.valid" class="coupon-field__error">
        {{ couponValid.error }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CouponField",
  data() {
    return {
      expanded: false,
      code: "",
      loading: false
    };
  },
  computed: {
    couponValid() {
      return this.$store.getters.couponValid;
    }
  },
  methods: {
    async applyCoupon() {
      if (!this.code) return;

      // Require a plan to be selected first
      if (!this.$store.getters.selectedPlan) {
        this.$store.commit("SET_COUPON_VALID", {
          valid: false,
          error: "Primero selecciona un plan para aplicar el cupón"
        });
        return;
      }

      this.loading = true;
      this.$store.dispatch("setCouponCode", this.code.toUpperCase());
      await this.$store.dispatch("validateCoupon");
      this.loading = false;
    },
    clearCoupon() {
      this.code = "";
      this.$store.dispatch("clearCoupon");
    }
  }
};
</script>

<style lang="scss" scoped>
.coupon-field {
  &__trigger {
    cursor: pointer;
    text-align: center;

    &-text {
      font-size: 13px;
      color: #888780;
      text-decoration: underline;
      text-decoration-style: dashed;
      text-underline-offset: 3px;

      &:hover {
        color: #2d2b55;
      }
    }
  }

  &__form {
    max-width: 400px;
    margin: 0 auto;
  }

  &__input-wrap {
    display: flex;
    gap: 8px;
  }

  &__input {
    flex: 1;
    padding: 10px 14px;
    border: 1.5px solid #e8e7e3;
    border-radius: 10px;
    font-size: 13px;
    font-family: "Plus Jakarta Sans", sans-serif;
    text-transform: uppercase;
    outline: none;
    transition: border-color 0.2s;

    &::placeholder {
      color: #c8c7c2;
      font-weight: 400;
    }

    &:focus {
      border-color: #3ecfb4;
    }
  }

  &__btn {
    padding: 10px 20px;
    border: none;
    border-radius: 10px;
    background: #2d2b55;
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    font-family: "Plus Jakarta Sans", sans-serif;
    white-space: nowrap;
    transition: background 0.15s;

    &:hover:not(:disabled) {
      background: #1e1c42;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  &__success {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 8px;
    padding: 8px 12px;
    background: #ecfdf5;
    border-radius: 8px;
    font-size: 13px;
    color: #1d9e75;
    font-weight: 500;
  }

  &__clear {
    margin-left: auto;
    border: none;
    background: none;
    color: #888780;
    font-size: 18px;
    cursor: pointer;
    padding: 0 4px;
    line-height: 1;
  }

  &__error {
    margin-top: 8px;
    font-size: 13px;
    color: #f56c6c;
  }
}
</style>
